"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WebRenderer = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
require("../../styles/CanvasPreview.scss");
const BabylonCanvas_1 = require("../../classes/BabylonCanvas");
const webXRBrowserSupportUtil_1 = require("../../utils/webXRBrowserSupportUtil");
const CameraSelection_1 = require("./CameraSelection");
const MobileHint_1 = require("../MobileHint");
exports.WebRenderer = (0, react_1.forwardRef)((props, ref) => {
    const babylonRef = (0, react_1.useRef)(null);
    const canvasRef = (0, react_1.createRef)();
    const [description, setDescription] = (0, react_1.useState)();
    const [cameras, setCameras] = (0, react_1.useState)([]);
    const [elementId, setElementId] = (0, react_1.useState)();
    const [progress, setProgress] = (0, react_1.useState)(0);
    const [arKitSupported, setArKitSupported] = (0, react_1.useState)(true);
    const [arGeneralSupport, setArGeneralSupport] = (0, react_1.useState)(false);
    const [arAppStarted, setArAppStarted] = (0, react_1.useState)(false);
    const browserSupport = (0, webXRBrowserSupportUtil_1.useARBrowserSupport)();
    /**
     * callback which is called when the model is loading
     * @param event
     */
    const onModelLoading = (event) => {
        setProgress(Math.round((event.loaded / event.total) * 100));
    };
    const getCameraPosition = () => { };
    const playAnimations = () => { };
    const onCameraSelectionChange = (camera) => {
        var _a;
        if (!camera)
            return;
        (_a = babylonRef.current) === null || _a === void 0 ? void 0 : _a.setCamera(camera);
    };
    const onCamerasReady = (cameras) => {
        setCameras(cameras);
    };
    const startAR = () => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b;
        setArAppStarted(true);
        try {
            if (browserSupport.isArKitSupported()) {
                (_a = babylonRef.current) === null || _a === void 0 ? void 0 : _a.startARKit();
                return;
            }
            const supported = yield browserSupport.isImmersiveArSupported();
            if (supported) {
                (_b = babylonRef.current) === null || _b === void 0 ? void 0 : _b.loadWebXR();
            }
        }
        catch (error) {
            console.log(error);
        }
    });
    const loadVR = () => {
        var _a;
        (_a = babylonRef.current) === null || _a === void 0 ? void 0 : _a.loadWebXR();
    };
    const updateClickedElement = (id, x, y) => {
        setElementId(id);
    };
    (0, react_1.useEffect)(() => {
        if (props.forceStartAR) {
            startAR()
                .then(() => console.log("started"), () => console.log("not started"))
                .catch(() => console.log("failed"));
        }
    }, [props.forceStartAR]);
    const updateDescription = (description) => {
        setDescription(description);
    };
    (0, react_1.useEffect)(() => {
        var _a, _b;
        setArGeneralSupport(browserSupport.isArKitSupported());
        browserSupport
            .isImmersiveArSupported()
            .then((support) => setArGeneralSupport(support));
        setArKitSupported(document.createElement("a").relList.supports("ar"));
        if (!canvasRef.current) {
            console.error("canvas ref is not defined!");
            return;
        }
        babylonRef.current = new BabylonCanvas_1.BabylonCanvas({
            withLighting: false,
            withZoom: true,
            withRandomModelColors: false,
            descriptions: props.descriptions,
            decoderPath: "/ar-prototype/node_modules/three/examples/jsm/libs/draco/gltf/",
            htmlElement: canvasRef.current,
            onClick: (elementId, posX, posY) => updateClickedElement(elementId, posX, posY),
            onDescriptedMeshSelected: updateDescription,
            onLoading: onModelLoading,
            onCamerasReady: onCamerasReady,
            onError: (error) => console.log(error),
            isCompressed: true,
            rootUrl: "",
            sceneFileName: (_a = props.fileUrlAndroid) !== null && _a !== void 0 ? _a : "scene.glb",
            usdFileName: (_b = props.fileUrl) !== null && _b !== void 0 ? _b : "scene.usdz",
            preferredCameraId: "default camera",
            cameraAlpha: props.cameraAlpha,
            cameraBeta: props.cameraBeta,
            cameraRadius: props.cameraRadius,
            cameraVectorX: props.cameraVectorX,
            cameraVectorY: props.cameraVectorY,
            cameraVectorZ: props.cameraVectorZ,
            withTransparency: props.withTransparency,
            scaleWebXR: props.scaleWebXR,
        });
        if (props.forceStartAR) {
            startAR()
                .then(() => console.log("started"), () => console.log("not started"))
                .catch(() => console.log("failed"));
        }
        if (props.scrollIntoView && canvasRef.current) {
            canvasRef.current.scrollIntoView({
                behavior: "smooth",
                block: "end",
            });
        }
    }, []);
    return ((0, jsx_runtime_1.jsxs)("div", { style: { position: "relative" }, children: [(0, jsx_runtime_1.jsx)("div", { className: "row", children: (0, jsx_runtime_1.jsx)("div", { className: "small-12 medium-12 large-12 columns", children: cameras && props.showCameraSelection && ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsx)(CameraSelection_1.CameraSelection, { cameras: cameras, onChange: (c) => onCameraSelectionChange(c) }) })) }) }), progress && progress < 100 && progress > 0 && ((0, jsx_runtime_1.jsxs)("div", { className: "canvas--loading", style: {
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    zIndex: 100,
                    textAlign: "center",
                    transform: "translate(-50%, -50%)",
                }, children: [(0, jsx_runtime_1.jsxs)("strong", { children: [progress, "%"] }), (0, jsx_runtime_1.jsx)("progress", { value: progress, max: 100 })] })), (0, jsx_runtime_1.jsxs)("div", { ref: ref, className: "canvas-preview", style: {
                    position: "relative",
                }, onClick: loadVR, children: [props.showMobileHint &&
                        !arGeneralSupport &&
                        (props.forceStartAR || arAppStarted) && ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: (0, jsx_runtime_1.jsx)(MobileHint_1.MobileHint, { url: props.articleAppUrl, onClose: () => props.onMobileHintClose() }) })), (0, jsx_runtime_1.jsx)("canvas", { width: "100%", className: "canvas-preview--ui", ref: canvasRef }), (description === null || description === void 0 ? void 0 : description.length) && ((0, jsx_runtime_1.jsx)("div", { className: "canvas-preview--description", children: description }))] })] }));
});
